export default "__VITE_ASSET__Bu1EGsxP__"